import { useState } from "react";
import { Send, CheckCircle2, Mail, Phone, MapPin } from "lucide-react";
import { Api } from "../lib/api";

export default function ContactPage() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(null);

  async function submit(e) {
    e.preventDefault();
    setLoading(true);
    setErr(null);
    try {
      await Api.createContact({ name, email, message });
      setDone(true);
    } catch (ex) {
      setErr("Could not send message. Try email instead.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="container-x py-12 md:py-20" data-testid="contact-page">
      <p className="eyebrow">Get in touch</p>
      <h1 className="heading-xl mt-2">
        Questions, ideas or <span className="italic-accent">a collaboration?</span>
      </h1>
      <p className="body-lead mt-3 max-w-xl">
        We&apos;d love to hear from you. Drop us a line and we&apos;ll come back within 48 hours.
      </p>
      <div className="mt-10 grid md:grid-cols-3 gap-8">
        <div className="md:col-span-2">
          {done ? (
            <div className="card p-7 text-center" data-testid="contact-success">
              <div className="w-14 h-14 rounded-full bg-coral/10 text-coral flex items-center justify-center mx-auto mb-3">
                <CheckCircle2 size={26} />
              </div>
              <p className="font-serif text-2xl text-navy">Message sent!</p>
              <p className="text-grey text-sm mt-2">We&apos;ll come back within 48 hours.</p>
            </div>
          ) : (
            <form onSubmit={submit} className="card p-7 space-y-3" data-testid="contact-form">
              <input
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                placeholder="Your name"
                className="w-full rounded-xl border border-[#EFE7D2] p-3 bg-cream/40"
                data-testid="contact-name"
              />
              <input
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                type="email"
                placeholder="Your email"
                className="w-full rounded-xl border border-[#EFE7D2] p-3 bg-cream/40"
                data-testid="contact-email"
              />
              <textarea
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                required
                rows={5}
                placeholder="Your message"
                className="w-full rounded-xl border border-[#EFE7D2] p-3 bg-cream/40"
                data-testid="contact-message"
              />
              {err && (
                <p className="text-red text-sm" data-testid="contact-error">
                  {err}
                </p>
              )}
              <button
                disabled={loading}
                className="btn-primary disabled:opacity-50"
                data-testid="contact-submit"
              >
                {loading ? "Sending…" : "Send message"} <Send size={16} />
              </button>
            </form>
          )}
        </div>
        <aside className="space-y-4">
          <div className="card p-5">
            <p className="eyebrow">Email</p>
            <a
              className="text-navy font-bold mt-1 inline-flex items-center gap-2"
              href="mailto:hello@picnicinthepark.se"
            >
              <Mail size={14} />
              hello@picnicinthepark.se
            </a>
          </div>
          <div className="card p-5">
            <p className="eyebrow">Phone</p>
            <a
              className="text-navy font-bold mt-1 inline-flex items-center gap-2"
              href="tel:+4685424991"
            >
              <Phone size={14} />
              +46 8 542 49 491
            </a>
          </div>
          <div className="card p-5">
            <p className="eyebrow">Location</p>
            <p className="text-navy font-bold mt-1 inline-flex items-center gap-2">
              <MapPin size={14} />
              Grinda, Stockholm archipelago
            </p>
          </div>
        </aside>
      </div>
    </div>
  );
}
